<div class="d-flex align-items-center">
  <div
    class="c-field-value__shape-circle -sale-status mr-6"
    [ngClass]="{
      '-blocked': +data === 0,
      '-active': +data === 1,
      '-pending': +data === 2
    }"
  ></div>
  <span>{{ statusNames[+data] }}</span>
</div>
